import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { PrintService } from 'src/app/services/print.service';
import { TABS } from 'src/app/dummy/tab';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { CurriculumStore } from 'src/app/stores/resources/curriculum.store';
import { AddProgramLevelLessonModuleComponent } from '../add-program-level-lesson-module/add-program-level-lesson-module.component';
import { DataService } from 'src/app/services/data.service';
import { pushToObject } from 'src/app/services/convert.service';

@Component({
  selector: 'app-program-level-lesson-module',
  templateUrl: './program-level-lesson-module.component.html',
  styleUrls: ['./program-level-lesson-module.component.scss']
})
export class ProgramLevelLessonModuleComponent implements OnInit {
  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  tabs: any = TABS.PROGRAM_LESSON;
  PROGRAM_KEY: any;
  LEVEL_KEY: any;
  LESSON_KEY: any;
  LESSON: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public store: CurriculumStore,
    private auth: AuthStore,
    public ps: PrintService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private ds: DataService,
  ) { }

  ngOnInit() {
    this.route.params.subscribe(async (param) => {
      const { programKey, levelKey, lessonKey } = param;
      this.PROGRAM_KEY = programKey;
      this.LEVEL_KEY = levelKey;
      this.LESSON_KEY = lessonKey;
      this.tabs = TABS.PROGRAM_MODULE.map(m => ({ path: `/programs/${this.PROGRAM_KEY}/${this.LEVEL_KEY}/${this.LESSON_KEY}/${m.route}`, label: m.label }))
      this.LESSON = pushToObject(await this.ds.lessonColRef().doc(this.LESSON_KEY).get().toPromise());
      this.store.fetchProgramModules(this.PROGRAM_KEY, this.LEVEL_KEY,this.LESSON_KEY);
      
    })
  }

  addItem(item: any) {
    let dialogRef = this.dialog.open(AddProgramLevelLessonModuleComponent, {
      data: {
        MODULE: item,
        PROGRAM_KEY: this.PROGRAM_KEY,
        LEVEL_KEY: this.LEVEL_KEY,
        LESSON_KEY: this.LESSON_KEY,
       
      },
      panelClass: 'item-list-panel',
      width: '',
      height: '100vh',
      disableClose: true,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => { });
  }


  delete(item: any) {
    let dialogRef = this.dialog.open(DeleteComponent, {
      data: item,
      panelClass: 'cs-overlay-panel',
      width: '',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.store.removeModule(item, this.LESSON_KEY, this.LEVEL_KEY, this.PROGRAM_KEY, this.auth.user.uid, (success) => {
          if (success) {
            this.snackBar.open("Module and activity has been deleted successful.", "Done", { duration: 2500 });
          }
        })
      }
    });
  }
}
